import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const tableSx: SxProps<Theme> = {
    border: 'none',
    borderRadius: 0,
    '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
        outline: 'none !important',
    },
};

/** A value the record does not carry yet - the em dash reads better than an empty cell. */
export const mutedDashSx: SxProps<Theme> = {
    color: theme.palette.neutral[400],
};

export const nameCellSx: SxProps<Theme> = {
    fontWeight: 500,
};

// --- Row actions (matches the sibling tables' style) -----------------------
export const actionsRootSx: SxProps<Theme> = {
    flexDirection: 'row',
    justifyContent: 'flex-end',
};

export const actionsButtonSx: SxProps<Theme> = {
    width: '28px',
    height: '28px',
    p: '2px',
    color: theme.palette.neutral[400],
    backgroundColor: 'transparent',
    '.MuiSvgIcon-root': {
        fill: theme.palette.neutral[400],
    },
    '&:not(:last-child)': {
        mr: 1,
    },
};

export const actionsIconSx: SxProps<Theme> = {
    width: '20px',
};

// --- Footer "add" row ------------------------------------------------------
export const addButtonSx: SxProps<Theme> = {
    // The whole footer, not a button sitting in it: the row is the affordance, so it spans the
    // card edge to edge under the last table row.
    width: '100%',
    padding: theme.spacing(10 / 8, 16 / 8),
    backgroundColor: theme.palette.background.default,
    borderTop: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:active': {
        backgroundColor: theme.palette.action.selected,
    },
};

// --- Add-credential form ---------------------------------------------------
export const formSx: SxProps<Theme> = {
    display: 'grid',
    gridTemplateColumns: 'auto',
    gap: theme.spacing(20 / 8),
    padding: theme.spacing(20 / 8),
};

export const actionsWrapperSx: SxProps<Theme> = {
    padding: theme.spacing(20 / 8, 24 / 8),
    borderTop: `${theme.spacing(1 / 8)} solid ${theme.palette.neutral[200]}`,
    background: theme.palette.neutral[50],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(20 / 8),
};

/** The menu the card's head opens, as the sibling cards draw it. */
export const popoverSx: SxProps<Theme> = {
    '& .MuiPaper-root': {
        maxWidth: theme.spacing(200 / 8),
        width: '100%',
        p: 1,
    },
};

export const menuContentSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
};

export const menuButtonSx: SxProps<Theme> = {
    width: '100%',
};

export const menuButtonTextSx: SxProps<Theme> = {
    width: '100%',
    textAlign: 'start',
    fontSize: theme.spacing(14 / 8),
    fontWeight: 400,
    color: theme.palette.neutral[400],
};
